import React, { useState, useEffect } from 'react'
import SearchWidget from '../../../shared/components/SearchWidget';



const Promo = ({value=0, onChoose}) => {
    const items = [
        {id: 0, name: 'Любой тариф'},
        {id: 1, name: 'Базовый тариф'},
        {id: 2, name: 'Промо тариф'},
    ];
    const title = !!value ? value == 1 ? `Базовый тариф` : `Промо тариф` : `Любой тариф`
  return <SearchWidget
    cssClass="promo"
    type="select"
    label="Тариф"
    title={title}
    items={items}
    value={value}
    buttonDone={false}
    onChoose={onChoose} />
}

export default Promo;